<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست پرداخت ها به ' + contact.businessName">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items"
					:footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" :search="search"
					class="elevation-1">
					<template v-slot:item.saveDate_Persian="{ item }">
						{{ item.saveDate_Persian.date }} {{ item.saveDate_Persian.time }}
					</template>
					<template v-slot:item.amount="{ item }">
						{{ item.amount.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.userLoanContact.userLoanAmount="{ item }">
						{{ item.userLoanContact.userLoanAmount.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.userLoanContact.share="{ item }">
						{{ item.userLoanContact.share.toString().toPriceFormat() }}
					</template>
					<template v-slot:item.successfullOnlineMoneyTransferId="{ item }">
						<v-icon color="success" v-if="!!item.successfullOnlineMoneyTransferId" title="دارای تراکنش آنلاین"
							small>mdi-credit-card-check-outline</v-icon>
					</template>
					<template v-slot:item.operations="{ item }">
						<td class="text-center">
							<v-btn class="mx-1" fab dark x-small color="pink" @click="removeTransaction(item)">
								<v-icon dark small>
									mdi-trash-can-outline
								</v-icon>
							</v-btn>
						</td>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'

export default {
	name: 'ContactTransactions',
	props: {
		contact: { type: Object },
		userLoanContact: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
	},
	data() {
		return {
			errorMessages: '',
			search: '',
			loading: false,
			headers: [
				{
					text: 'تاریخ واریز',
					align: 'center',
					sortable: true,
					value: 'saveDate_Persian',
				}, {
					text: 'مبلغ تراکنش',
					align: 'start',
					sortable: true,
					value: 'amount',
				},
				{
					text: 'شماره وام',
					align: 'start',
					sortable: true,
					value: 'userLoanContact.userLoanCode',
				},
				{
					text: 'مبلغ وام',
					align: 'start',
					sortable: true,
					value: 'userLoanContact.userLoanAmount',
				},
				{
					text: 'سهم نماینده',
					align: 'start',
					sortable: true,
					value: 'userLoanContact.share',
				},
				{
					text: 'توضیحات',
					align: 'start',
					sortable: true,
					value: 'description',
				},
				{
					text: '',
					align: 'start',
					sortable: true,
					value: 'successfullOnlineMoneyTransferId',
					width: 30
				},
				{
					text: 'عملیات ها',
					align: 'center',
					sortable: false,
					value: 'operations',
				}
			],
			items: [],
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('admin/transaction/ListByContactId/' + this.contact.id + (this.userLoan ? '/' + this.userLoanContact.id : ''), null)
				.then(response => {
					this.items = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		async removeTransaction(item) {
			if (!item) { return }

			if (await this.$refs.confirm.open(
				'توجه',
				'آیا از حذف این آیتم مطمئن هستید؟',
			)) {
				api.post('admin/transaction/delete/' + item.id)
					.then(
						response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadData()
							this.$emit('update')
						})
					.catch(err => {
						toast.error(err.message)
					})
			}
		}
	},
}
</script>
<style></style>
